import { Box } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

const Badge = ({ type }) => {
    const findColor = () => {
      if (type === 'success') {
        return '#00B596'
      } else {
        return '#D14343'
      }
    }

    const findIcon = () => {
      if (type === 'success') {
        return faCheckCircle
      } else {
        return faXmarkCircle
      }
    }

    const findText = () => {
      if (type === 'success') {
        return 'Matched!'
      } else {
        return 'Unmatched'
      }
    }

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="126px"
        height="36px"
        color="#fff"
        sx={{ background: `${findColor()}` }}
        borderRadius="20px"
      >
        <Box display="flex" alignItems="center" gap="10px">
          <Box>
            <FontAwesomeIcon fontSize="16px" className="font-weight-bold" icon={findIcon()} />
          </Box>
          <Box>{findText()}</Box>
        </Box>
      </Box>
    )
};

export default Badge;